import {
  BellRing,
  CalendarDays,
  CheckSquare,
  FolderKanban,
  History,
  Search,
  SunMedium,
  Upload,
  Users,
} from 'lucide-react';

export const appNavigationItems = [
  {
    path: '/queue',
    label: 'Upload',
    description: 'Send new items into the workspace',
    icon: Upload,
    matches: (pathname) => pathname === '/queue',
  },
  {
    path: '/notifications',
    label: 'Inbox',
    description: 'Review alerts and unread updates',
    icon: BellRing,
    matches: (pathname) => pathname === '/notifications',
  },
  {
    path: '/history',
    label: 'History',
    description: 'Review recent activity and outcomes',
    icon: History,
    matches: (pathname) => pathname === '/history',
  },
  {
    path: '/search',
    label: 'Search',
    description: 'Ask across workspace context',
    icon: Search,
    matches: (pathname) => pathname === '/search',
  },
  {
    path: '/briefing',
    label: 'Briefing',
    description: 'Start from the shape of the day',
    icon: SunMedium,
    matches: (pathname) => pathname === '/briefing',
  },
  {
    path: '/lists',
    label: 'Collections',
    description: 'Browse personal and family lists',
    icon: FolderKanban,
    matches: (pathname) => pathname.startsWith('/lists'),
  },
  {
    path: '/tasks',
    label: 'Tasks',
    description: 'Track open work and follow-ups',
    icon: CheckSquare,
    matches: (pathname) => pathname === '/tasks',
  },
  {
    path: '/calendar',
    label: 'Calendar',
    description: 'See what is scheduled next',
    icon: CalendarDays,
    matches: (pathname) => pathname === '/calendar',
  },
  {
    path: '/family',
    label: 'Family',
    description: 'Manage shared access and household state',
    icon: Users,
    matches: (pathname) => pathname === '/family',
  },
];

export function getCurrentPageTitle(pathname) {
  const path = pathname.split('/')[1];
  if (path === 'lists') return 'Collections';
  if (path === 'queue') return 'Upload';

  const matched = appNavigationItems.find((item) => item.matches(pathname));
  return matched?.label || 'Dashboard';
}

export function getCurrentNavItem(pathname) {
  return appNavigationItems.find((item) => item.matches(pathname)) || null;
}
